module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "five-nav flex-start"
  }, _vm._l((_vm.content), function(item, index) {
    return _c('div', {
      on: {
        "click": function($event) {
          return _vm.goGoodsList(item.url.name, item.url.query.cate_id)
        }
      }
    }, [_c('div', {
      staticClass: "nav-img-box"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.2rem",
        "font-size": "11px",
        "color": "#333"
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21f0cd7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/NavButton.vue
// module id = 2273
// module chunks = 0